import _isError from "lodash/isError";
import _get from "lodash/get";
import _parseInt from "lodash/parseInt";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import { createBrowserHistory } from 'history';
import qs from 'qs';
import * as React from 'react';
import useAsync from 'react-use/lib/useAsync';
import { teachApiClient } from '../api/teachApiClient';
export const PreviewLoader = _ref => {
  let {
    chapterHash,
    children,
    courseHash,
    environment,
    exerciseId,
    getData,
    onError,
    setData,
    validate
  } = _ref;
  const exercise = getData(exerciseId);
  const [history] = React.useState(createBrowserHistory());
  const {
    error
  } = useAsync(async () => {
    if (!_isEmpty(exercise)) {
      return;
    }
    if (_isNil(courseHash) || _isNil(chapterHash)) {
      throw new Error('The course/chapter id is not defined');
    }
    const teachClient = teachApiClient(environment);
    const course = await teachClient.getCourse(courseHash);
    const exerciseData = await teachClient.getExercise(exerciseId, chapterHash, courseHash, {
      chapter_id: _parseInt(chapterHash),
      course_id: _parseInt(courseHash) || 1,
      language: course.programming_language
    }, validate);
    const {
      course_id: courseId
    } = qs.parse(history.location.search, {
      ignoreQueryPrefix: true
    });
    setData(exerciseId,
    // eslint-disable-next-line prefer-object-spread
    Object.assign({}, exerciseData, {
      course_id: _parseInt(courseId) || _get(exerciseData, 'course_id'),
      isRatingPermitted: false
    }));
  }, [exerciseId, courseHash, chapterHash, validate]);
  React.useEffect(() => {
    if (_isError(error)) {
      onError(error);
    }
  }, [environment, error, exerciseId, onError]);
  return React.useMemo(() => children({
    error,
    exercise
  }), [children, exercise, error]);
};